<template>
  <div :class="$store.getters['progress/isActive'] ? 'progress-is-active' : ''">

    <b-loading :is-full-page="isFullPage"
               :active.sync="isLoading"
               :can-cancel="false"

    >
      <div v-if="$store.getters['progress/isActive']" style="z-index: 99;">
        <vue-progress-bar style="top:none"></vue-progress-bar>
        <div id="processing-text" class="has-text-centered">
          Please, wait. The order is processing...
          <br>
          <br>
          <div class="button button is-info" v-on:click="abortOrderSubmission()">Cancel</div>
        </div>
      </div>
    </b-loading>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import EventBus from '@/event-bus'
export default {
  name: 'Loader',
  props: {
    isFullPage: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    ...mapGetters({ isLoading: 'loader/isLoading' })
  },

  methods: {
    abortOrderSubmission: () => {
      EventBus.$emit('ABORT_ORDER_SUBMISSION')
    }
  }
}
</script>
